import { createSelector } from 'reselect';

const selectFundingSearch = (state) => state.get('fundingSearch');

const selectFundingSearchPrivacyToggleModalState = () =>
  createSelector(selectFundingSearch, (state) =>
    state.getIn(['privateToggleFundingSearchModal', 'modalOpen']),
  );

const selectFundingSearchToPrivacyToggle = () =>
  createSelector(selectFundingSearch, (state) =>
    state.getIn(['privateToggleFundingSearchModal', 'fundingSearch']),
  );

export { selectFundingSearchToPrivacyToggle, selectFundingSearchPrivacyToggleModalState };
